import BaseApi from './baseAPI'

class PostAPI extends BaseApi{
  get entity() {
    return {
      route: `${this.getCourseId()}/posts`,
      name: 'المنشور'
    }
  }

  getByPageAll(page, limit, privacy) {
      return new Promise((resolve, reject) => {
        return this.request.get(`${this.entity.route}?page=${page}&limit=${limit}&privacy=${privacy}`)
            .then(response => resolve(this.responseWrapper(response)))
            .catch(error => reject(this.errorWrapper(error)))
      })

  }

  updatePoll(id, poll_id){
    return new Promise((resolve, reject) => {
      return this.request.put(`/${this.entity.route}/${id}/polls/${poll_id}`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  getAllByRout(route, page, limit, privacy) {
    return new Promise((resolve, reject) => {
      return this.request.get(`${route}/posts?page=${page}&limit=${limit}&privacy=${privacy}`)
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new PostAPI()
